const angular = require('angular');

const resourceInjector = require('./resource-injector-service');

angular.module('oly.common')
    .service('ResourceInjector', resourceInjector);



// WEBPACK FOOTER //
// ./src/olycommon/resources/index.js